import { render, staticRenderFns } from "./EfsStdFarmerStandardForm.vue?vue&type=template&id=5c55d06c&scoped=true&"
import script from "./EfsStdFarmerStandardForm.vue?vue&type=script&lang=js&"
export * from "./EfsStdFarmerStandardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55d06c",
  null
  
)

export default component.exports